import React, { useState } from "react";
import {
  Button,
  Grid,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  Typography,
  Card,
  TextField,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ArrowBack } from "@mui/icons-material";
import { Link } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import useButtonStyles from "../styles/useButtonStyles";

const ImportReceipt = () => {
  const theme = useTheme();
  const buttonStyles = useButtonStyles();
  const [file, setFile] = useState<File | null>(null);
  const [merchant, setMerchant] = useState("");

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    setFile(selectedFile || null);
  };

  const handleSave = () => {};

  return (
    <Grid container width={"100%"}>
      <Grid
        item
        width={"100%"}
        height={"6.25rem"}
        display={"flex"}
        alignItems={"center"}
        borderBottom={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
        sx={{ background: theme.color?.background }}
      >
        <Grid item display={"flex"} alignItems={"center"} px={4} gap={2}>
          <Link to="/receipts">
            <ArrowBackIosIcon />
          </Link>{" "}
          <Typography
            variant="h6"
            sx={{ color: theme?.color?.primary, fontWeight: "600" }}
          >
            Import Receipt
          </Typography>
        </Grid>
      </Grid>

      <Card
        raised={true}
        variant="outlined"
        sx={{
          m: { xs: 0, md: 0, lg: 6, xl: 6 },
          borderRadius: "20px",
          p: 4,
          width: "70%",
          minHeight: "40vh",
        }}
      >
        <Grid
          container
          borderRadius={"8px"}
          display={"flex"}
          height={"100%"}
          flexDirection={"column"}
          justifyContent={"space-between"}
          width={"100%"}
        >
          <Grid item container width={"100%"} display={"flex"}>
            <Grid
              lg={6}
              display={"flex"}
              flexDirection={"column"}
              item
              container
              rowSpacing={1}
              justifyContent={"center"}
              p={2}
            >
              <Grid item>
                <InputLabel htmlFor="csvFile" sx={{ fontWeight: "600" }}>
                  Import Receipt CSV file (Sample file)
                </InputLabel>
              </Grid>
              <Grid item>
                <FormControl>
                  <TextField
                    size="small"
                    type="text"
                    value={file?.name || ""}
                    inputProps={{ readOnly: true }}
                    style={{
                      borderRadius: "5px",
                    }}
                  />
                </FormControl>
                <FormControl>
                  <label htmlFor="csvFile">
                    <Typography
                      sx={{
                        ...buttonStyles.containedPrimary,
                        borderRadius: "4px",
                        py: 1.5,
                        px: 2,
                        mx: 2,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      Browse
                    </Typography>
                    <TextField
                      size="small"
                      type="file"
                      id="csvFile"
                      inputProps={{ accept: ".csv" }}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </label>
                </FormControl>
              </Grid>
              <Grid item>
                <small>Only Csv(.csv) file supported</small>
              </Grid>
            </Grid>
            <Grid
              lg={6}
              item
              display={"flex"}
              flexDirection={"column"}
              container
              width={"100%"}
              rowSpacing={1}
              p={2}
            >
              <Grid item>
                <InputLabel id="merchantLabel" sx={{ fontWeight: "600" }}>
                  Merchant
                </InputLabel>
              </Grid>
              <Grid item>
                <FormControl fullWidth>
                  <Select
                    sx={{ width: "80%" }}
                    size="small"
                    labelId="merchantLabel"
                    id="merchant"
                    value={merchant}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Merchant
                    </MenuItem>
                    <MenuItem value="merchant1">Merchant 1</MenuItem>
                    <MenuItem value="merchant2">Merchant 2</MenuItem>
                    <MenuItem value="merchant3">Merchant 3</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            container
            borderTop={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
          >
            <Grid
              item
              display={"flex"}
              justifyContent={"right"}
              width={"100%"}
              p={2}
              pt={4}
            >
              <Button
                sx={{ ...buttonStyles.outlinedSecondary, width: "25%", mr: 2 }}
                variant="outlined"
                component={Link}
                to="/receipts"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleSave}
                sx={{
                  ...buttonStyles.containedSecondary,
                  width: "25%",
                }}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
};

export default ImportReceipt;
